import 'css-chunksrc/client/pages/obsPage/toolbar/styles.scss';export default {
  "toolbar": "_toolbar_12ug7_1",
  "title": "_title_12ug7_8"
};